// Header.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css'; // Import CSS file for styling

const Header = () => {
    return (
        <header className="header">
            <h1 className="main-title">Creative Quotation</h1>
            <nav>
                <ul className="nav-list">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/contact-us">Contact Us</Link></li>
                    <li><Link to="/delete-account">Delete Account</Link></li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;
